import React from "react";
import { useLocation } from "react-router-dom";
import Coin from "../../../assets/coin 1.svg";
import Tick from "../../../assets/tick.svg";
import { useLoyaltyPoints } from "../../../hooks";
import LoadingComponent from "../../LoadingComponent";

const formatCurrency = (amount) =>
  amount.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

function LoyaltyDiscount() {
  const location = useLocation();
  const hookRes = useLoyaltyPoints();

  if (
    (hookRes.authToken && !hookRes.userDetails?.pointBalance) ||
    location.pathname.includes("payment") ||
    !parseFloat(hookRes.pointsRes?.points)
  ) {
    return null;
  }

  const renderContent = () => {
    if (!hookRes.authToken) {
      return (
        <DefaultContent
          message="Log In to see available BlueBees points"
          points={hookRes.pointsRes?.points}
          error={hookRes.error}
        />
      );
    }

    if (hookRes.applyDiscountsApi.loyaltyPoints)
      return (
        <AppliedContent
          message="Reward Applied"
          onRemove={hookRes.removePoints}
          applyDiscountsApi={hookRes.applyDiscountsApi}
          couponStatus={hookRes.couponStatus}
          error={hookRes.error}
        />
      );

    return (
      <AvailableContent
        points={Math.floor(hookRes.userDetails.pointBalance)}
        loyaltyPoints={hookRes.redeemPoints}
        onApply={hookRes.applyPoints}
        applyDiscountsApi={hookRes.applyDiscountsApi}
        couponStatus={hookRes.couponStatus}
        error={hookRes.error}
      />
    );
  };

  return (
    <div className="discount">
      <div className="discount-divi">{renderContent()}</div>
    </div>
  );
}

function DefaultContent({ message, points, error }) {
  return (
    <>
      <div className="discount-img">
        <img src={Coin} alt="Coin" />
      </div>
      <div className="right-discount">
        <div className="right-upper-discount">
          <h2>{message}</h2>
        </div>
        {points && (
          <div className="right-bottom">
            <h3>
              Get upto Rs.{formatCurrency(points)} extra off by using BlueBees
              points
            </h3>
          </div>
        )}
        {error && (
          <div className="error-message">
            <p>{error}</p>
          </div>
        )}
      </div>
    </>
  );
}

function AppliedContent({
  message,
  onRemove,
  applyDiscountsApi,
  couponStatus,
  error
}) {
  return (
    <>
      <div className="discount-img">
        <img src={Tick} alt="Tick" />
      </div>
      <div className="loyalty-discount-container">
        <h2 className="on-add-coupon">{message}</h2>
        <button
          className="coupon-button"
          type="button"
          onClick={() =>
            onRemove({
              loyaltyPoints: 0,
              discountCode: applyDiscountsApi.discountCode
            })
          }
          disabled={couponStatus === "pending"}
        >
          {couponStatus === "pending" ? (
            <LoadingComponent diameter="20" color="#aaaaaa" />
          ) : (
            "Remove"
          )}
        </button>
        {error && (
          <div className="error-message">
            <p>{error}</p>
          </div>
        )}
      </div>
    </>
  );
}

function AvailableContent({
  points,
  loyaltyPoints,
  onApply,
  applyDiscountsApi,
  couponStatus,
  error
}) {
  return (
    <>
      <div className="discount-img">
        <img src={Coin} alt="Coin" />
      </div>
      <div className="right-discount">
        <div className="right-upper-discount">
          <h2>{formatCurrency(points)} BlueBees points available</h2>
          <button
            type="button"
            className="coupon-button"
            onClick={() =>
              onApply({
                loyaltyPoints,
                discountCode: applyDiscountsApi.discountCode
              })
            }
            disabled={couponStatus === "pending"}
          >
            {couponStatus === "pending" ? (
              <LoadingComponent diameter="20" color="#aaaaaa" />
            ) : (
              "Apply"
            )}
          </button>
        </div>
        {!!loyaltyPoints && (
          <div className="right-bottom">
            <h3>
              Use {formatCurrency(Math.round(loyaltyPoints))} Points & Get Rs.
              {formatCurrency(Math.round(loyaltyPoints))} Discount
            </h3>
          </div>
        )}
        {error && (
          <div className="error-message">
            <p>{error}</p>
          </div>
        )}
      </div>
    </>
  );
}

export default LoyaltyDiscount;
